"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasterDataDistributionEventStats_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var MasterDataDistributionEvent_1 = require("./MasterDataDistributionEvent");
var MasterDataDistributionEventStats_Factory = /** @class */ (function () {
    function MasterDataDistributionEventStats_Factory() {
    }
    MasterDataDistributionEventStats_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Created: model.Created,
            DistributionEvent: MasterDataDistributionEvent_1.MasterDataDistributionEvent_Factory.CreateIncoming(model.DistributionEvent),
            DistributionEventId: model.DistributionEventId,
            Edited: model.Edited,
            ManagedTableId: model.ManagedTableId,
            RecordId: model.RecordId,
        };
        return result;
    };
    MasterDataDistributionEventStats_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Created: model.Created,
            DistributionEvent: MasterDataDistributionEvent_1.MasterDataDistributionEvent_Factory.CreateOutgoing(model.DistributionEvent),
            DistributionEventId: model.DistributionEventId,
            Edited: model.Edited,
            ManagedTableId: model.ManagedTableId,
            RecordId: model.RecordId,
        };
        return result;
    };
    return MasterDataDistributionEventStats_Factory;
}());
exports.MasterDataDistributionEventStats_Factory = MasterDataDistributionEventStats_Factory;
